import exportConfig from './exportConfig'
export default exportConfig
